export const formatPhoneNumber = (value: string): string => {
  // First, strip all non-digits
  const numbers = value.replace(/\D/g, '')

  // Limit to 10 digits if longer
  const trimmed = numbers.slice(0, 10)

  // Then format the numbers
  const match = trimmed.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/)
  if (!match) return ''

  const [, first, second, third] = match

  if (!second) return first
  if (!third) return `(${first}) ${second}`
  return `(${first}) ${second}-${third}`
}

/** Trim the phone number of type +12234567890 to 2234567890 */
export const trimPhoneNumber = (value: string): string => {
  return value.replace('+1', '').slice(-10)
}
